import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Auth from './Auth.js';
import axios from 'axios';

import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Help from './components/Help';

import SADashboard from './components/superadmin/Dashboard';
import SAProject from './components/superadmin/Project';
import SAProjectAdd from './components/superadmin/Project/Add';
import SASchoolAdd from './components/superadmin/School/Add';
import SASchool from './components/superadmin/School';
import SAGroup from './components/superadmin/Group';
import SAGroupAdd from './components/superadmin/Group/Add';
import SAGroupAdmins from './components/superadmin/Group/HandleAdmins';
import SAGroupAdminAdd from './components/superadmin/Group/AddAdmin';
import SAAdmin from './components/superadmin/Admin';
import SAAddStudent from './components/superadmin/Group/AddStudent';
import SAAddProject from './components/superadmin/Group/AddProject';
import SAShares from './components/superadmin/Group/Shares';
import SATransactions from './components/superadmin/Transactions';
import SATransaction from './components/superadmin/Transactions/Edit';
import SAMe from './components/superadmin/Admin/Me';
import SASales from './components/superadmin/Sales';

import ADashboard from './components/admin/Dashboard';
import AGroup from './components/admin/Group';
import AProject from './components/admin/Project';
import AAddStudent from './components/admin/Group/AddStudent';
import AShares from './components/admin/Group/Shares';
import AStudentTransactions from './components/admin/Project/StudentTransactions';
import AMe from './components/admin/Admin';

import Dashboard from './components/user/Dashboard';
import NewTransaction from './components/user/Transaction/New';

import './App.css';

axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('api_token');

/**
 * Hantering av privata routes som skickar besökaren till login-sidan om hen försöker
 * komma åt privata resurser utan att vara inloggad.
 */
function UserRoute({component: Component, ...rest}) {
    return (
        <Route {...rest} render={(props) => (Auth.isAuthenticated() === true && Auth.isUser() === true)
            ? <Component {...props} />
            : <Redirect to={{pathname: '/', state: {from: props.location}}} />}
        />
    )
}
function AdminRoute({component: Component, ...rest}) {
    return (
        <Route {...rest} render={(props) => (Auth.isAuthenticated() === true && Auth.isAdmin() === true)
            ? <Component {...props} />
            : <Redirect to={{pathname: '/', state: {from: props.location}}} />}
        />
    )
}
function SuperAdminRoute({component: Component, ...rest}) {
    return (
        <Route {...rest} render={(props) => (Auth.isAuthenticated() === true && Auth.isSuperAdmin() === true)
            ? <Component {...props} />
            : <Redirect to={{pathname: '/', state: {from: props.location}}} />}
        />
    )
}

/**
 * Hantering av routes som används av utloggade användare. Om användaren är inloggad så
 * skickas hen till dashboarden.
 */
function GuestRoute({ component: Component, authed, ...rest }) {
    if (Auth.isAuthenticated() === true && Auth.isUser() === true) {
        return (
            <Route {...rest} render={ (props) =>
                <Redirect to={ {pathname: '/app', state: {from: props.location}} } />
            } />
        );
    } else if (Auth.isAuthenticated() === true && Auth.isAdmin() === true) {
        return (
            <Route {...rest} render={ (props) =>
                <Redirect to={ {pathname: '/admin/app', state: {from: props.location}} } />
            } />
        );
    } else if (Auth.isAuthenticated() === true && Auth.isSuperAdmin() === true) {
        return (
            <Route {...rest} render={ (props) =>
                <Redirect to={ {pathname: '/superadmin/app', state: {from: props.location}} } />
            } />
        );
    } else {
        return (
            <Route {...rest} render={ (props) =>
                <Component {...props} />
            } />
        );
    }
}

class App extends Component {
    render() {
        return (
            <Router>
                <div className="App">
                    {/* Öppna routes */}
                    <GuestRoute path="/" exact component={ Login } />
                    <GuestRoute path="/admin" exact component={ AdminLogin } />
                    <GuestRoute path="/glomt-losenord" exact component={ ForgotPassword } />
                    <GuestRoute path="/aterstall-losenord" exact component={ ResetPassword } />
                    <GuestRoute path="/hjalp" exact component={ Help } />


                    {/* Routes för vanliga användare */}
                    <UserRoute path="/app" exact component={ Dashboard } />

					<UserRoute path="/transactions/new/:project_id" exact component={ NewTransaction } />


                    {/* Routes för administratörer */}
                    <AdminRoute path="/admin/app" exact component={ ADashboard } />

                    <AdminRoute path="/admin/me" exact component={ AMe } />

                    <AdminRoute path="/admin/groups/:id" exact component={ AGroup } />

                    <AdminRoute path="/admin/projects/:group_id/:project_id" exact component={ AProject } />
                    <AdminRoute path="/admin/projects/:group_id/:project_id/:user_id" exact component={ AStudentTransactions } />

                    <AdminRoute path="/admin/students/add/:group_id" exact component={ AAddStudent } />
                    <AdminRoute path="/admin/shares/:group_id/:project_id" exact component={ AShares } />


                    {/* Routes för Superadministratörer */}
                    <SuperAdminRoute path="/superadmin/app" exact component={ SADashboard } />

                    <SuperAdminRoute path="/superadmin/me" exact component={ SAMe } />

                    <SuperAdminRoute path="/superadmin/projects/add" exact component={ SAProjectAdd } />
                    <SuperAdminRoute path="/superadmin/projects/edit/:id" exact component={ SAProject } />

                    <SuperAdminRoute path="/superadmin/schools/add" exact component={ SASchoolAdd } />
                    <SuperAdminRoute path="/superadmin/schools/edit/:id" exact component={ SASchool } />

                    <SuperAdminRoute path="/superadmin/groups/add/:school_id" exact component={ SAGroupAdd } />
                    <SuperAdminRoute path="/superadmin/groups/edit/:id" exact component={ SAGroup } />
                    <SuperAdminRoute path="/superadmin/groups/admins/handle/:id" exact component={ SAGroupAdmins } />
                    <SuperAdminRoute path="/superadmin/groups/admins/add/:id" exact component={ SAGroupAdminAdd } />

                    <SuperAdminRoute path="/superadmin/admins/edit/:id" exact component={ SAAdmin } />
                    <SuperAdminRoute path="/superadmin/students/add/:group_id" exact component={ SAAddStudent } />
                    <SuperAdminRoute path="/superadmin/projects/add/:group_id" exact component={ SAAddProject } />
                    <SuperAdminRoute path="/superadmin/shares/:group_id/:project_id" exact component={ SAShares } />

                    <SuperAdminRoute path="/superadmin/transactions" exact component={ SATransactions } />
                    <SuperAdminRoute path="/superadmin/transactions/:id" exact component={ SATransaction } />

                    <SuperAdminRoute path="/superadmin/sales" exact component={ SASales } />
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js